<app-main-layout>
  <app-event-form-page></app-event-form-page>
</app-main-layout>
